export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20warm%20reading%20nook%20with%20manga%20volumes%20stacked%20on%20wooden%20shelves%2C%20soft%20amber%20lamp%20light%2C%20comfortable%20armchair%20with%20open%20comic%20book%2C%20peaceful%20atmospheric%20interior%2C%20warm%20cream%20and%20wood%20tones%2C%20editorial%20lifestyle%20photography%20with%20gentle%20natural%20light&width=800&height=600&seq=about-manga&orientation=landscape"
                alt="5151漫画网 - 舒适阅读环境"
                className="w-full h-full object-cover object-center rounded-2xl"
              />
            </div>
          </div>

          <div className="flex-1 order-1 lg:order-2 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-primary-100 rounded-full mb-4">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-information-line text-primary-600 text-sm"></i>
              </div>
              <span className="text-xs font-medium text-primary-700 whitespace-nowrap">
                关于我们
              </span>
            </div>

            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-5">
              5151漫画网 · 您的掌上漫画图书馆
            </h2>

            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                5151漫画网成立于2019年，是国内领先的51漫画下载与在线阅读平台，致力于为漫画爱好者打造最便捷、最全面的一站式阅读体验。
                我们收录了超过10000部热门日漫、国漫、韩漫高清资源，涵盖热血、恋爱、悬疑、搞笑、奇幻、科幻等全品类题材，
                支持51漫画免费版下载和离线缓存功能，让用户随时随地畅享无网络阅读。
              </p>
              <p>
                平台采用高速CDN分发系统，确保51漫画下载资源极速传输，一键批量缓存，全集离线看。
                每日同步更新最新连载话数与经典完结作品，永久收藏热门漫画，是51漫画下载爱好者最值得信赖的资源站。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-7">
              <div className="text-center">
                <p className="font-heading text-2xl text-primary-500">10000+</p>
                <p className="text-xs text-foreground-500 mt-1">漫画资源</p>
              </div>
              <div className="text-center">
                <p className="font-heading text-2xl text-accent-500">500万+</p>
                <p className="text-xs text-foreground-500 mt-1">月活读者</p>
              </div>
              <div className="text-center">
                <p className="font-heading text-2xl text-primary-500">99.9%</p>
                <p className="text-xs text-foreground-500 mt-1">服务可用率</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}